import {Placement} from '@popperjs/core';
import React, {FC, ReactNode} from 'react';

import {BillingUpgradeWantedFeaturesEnum} from '../../../../../libs/shared/billing/business/src/billingUpgradeTypes';
import {hasFeature} from '../../../../../libs/shared/core/src/helpers/models/billingHelpers';
import {CompanyFeaturesEnum} from '../../../../../libs/shared/core/src/models/api/company/companyModel';
import {getCommonCompany} from '../../../../../libs/shared/core/src/store/data/company/commonCompanySelectors';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {BillingUpgradeTooltipWrapper} from '../../../../settings/billing/common/upgrade/billingUpgradeTooltipWrapper';

/*
 * Props.
 */

interface AnalyticsBillingUpgradeTooltipProps {
  children: React.ReactNode;
  isItemDisabled: boolean;
  placement?: Placement;
  analyticsBillingUpgradeTooltipRef?: React.RefObject<HTMLDivElement>;
  feature?: BillingUpgradeWantedFeaturesEnum;
}

/*
 * Component.
 */

export const AnalyticsBillingUpgradeTooltip: FC<AnalyticsBillingUpgradeTooltipProps> = ({
  children,
  isItemDisabled,
  placement = 'right',
  analyticsBillingUpgradeTooltipRef,
  feature,
}) => {
  const company = useAppSelector(getCommonCompany);
  let tooltipFeature;
  if (hasFeature(CompanyFeaturesEnum.MEDIUM_ANALYTICS_TIME_RANGE, company.features)) {
    tooltipFeature = BillingUpgradeWantedFeaturesEnum.ANALYTICS_775_RETENTION_DAYS;
  } else {
    tooltipFeature = BillingUpgradeWantedFeaturesEnum.ANALYTICS_217_RETENTION_DAYS;
  }

  return (
    <BillingUpgradeTooltipWrapper
      isBillingUpgradeRequired={isItemDisabled}
      feature={feature ?? tooltipFeature}
      billingUpgradeTooltipRef={analyticsBillingUpgradeTooltipRef}
      placement={placement}
    >
      {children}
    </BillingUpgradeTooltipWrapper>
  );
};

/*
 * Helpers.
 */

export const analyticsBillingUpgradeTooltipWrapperRenderer = (
  children: ReactNode,
  isItemDisabled: boolean,
  feature?: BillingUpgradeWantedFeaturesEnum,
  tooltipKey?: React.Key,
) => (
  <AnalyticsBillingUpgradeTooltip isItemDisabled={isItemDisabled} key={tooltipKey} feature={feature}>
    {children}
  </AnalyticsBillingUpgradeTooltip>
);
